/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PlcHttpConfig, PlcHttpConfigToken } from './services.models';

import { UpdateAlphabetSoupRoundRequest } from '../models/update-alphabet-soup-round.request';
import { AlphabetSoupRound } from '../models/alphabet-soup-round.entity';

export type AlphabetSoupRoundUpdatePathVariables = {
	gameId: string;
	roundId: string;
};

@Injectable()
export class AlphabetSoupRoundService {
	constructor(
		@Inject(PlcHttpConfigToken) private config: PlcHttpConfig,
		private http: HttpClient,
	) {}

	public update(
		path: AlphabetSoupRoundUpdatePathVariables,
		body: UpdateAlphabetSoupRoundRequest,
	): Observable<AlphabetSoupRound> {
		return this.http.patch<AlphabetSoupRound>(
			`${this.config.apiUrl}/api/v2/private/games/${path.gameId}/phases/soups/${path.roundId}`,
			body,
		);
	}
}
